module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_yycj_one.edff3144.png";